import React, { memo } from 'react';

import MSPlaidLink from './MSPlaidLink';
import DefaultPlaidLink from './DefaultPlaidLink';

interface PlaidLinkProps {
  ready: boolean;
  isMorganStanleyFlow: boolean;
  receivedRedirectUri: string;
  openWithTracking: () => void;
}

function PlaidLink({
  ready,
  isMorganStanleyFlow,
  receivedRedirectUri,
  openWithTracking
}: PlaidLinkProps) {
  if (receivedRedirectUri) return null;

  return isMorganStanleyFlow ? (
    <MSPlaidLink handleOnClick={openWithTracking} />
  ) : (
    <DefaultPlaidLink ready={ready} handleOnClick={openWithTracking} />
  );
}

export default memo(PlaidLink);
